<template>
  <div
    class="card my-3"
    :class="{ 'border-info': comment.student_id && !comment.is_read }"
  >
    <div class="card-body">
      <div class="row">
        <div class="col">
          <span>{{ comment.lecture.section.course.title }}</span>
          <br />
          <span>{{ comment.lecture.title }}</span>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div class="card bg-light">
            <div class="card-body">
              <div class="row" v-if="comment.user_id">
                <div class="ms-3">
                  <i class="fas fa-chalkboard-teacher fa-3x"></i>
                </div>
                <div class="col">
                  <span>
                    <b>{{ comment.user.name }}</b>
                  </span>
                  <small class="text-secondary">{{ comment.created_at }}</small>
                  <p class="m-0">{{ comment.body }}</p>
                </div>
              </div>
              <div class="row" v-else-if="comment.student_id">
                <div class="ms-3">
                  <i class="far fa-smile fa-3x"></i>
                </div>
                <div class="col">
                  <span>
                    <b>{{ comment.student.name }}</b>
                  </span>
                  <small class="text-secondary">{{ comment.created_at }}</small>
                  <p class="m-0">{{ comment.body }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-2 mt-sm-3 mt-md-0">
          <button
            v-if="comment.student_id"
            @click="toggle"
            ref="button"
            :class="{
              'btn btn-primary': !comment.is_read,
              'btn btn-outline-secondary': comment.is_read,
            }"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="comment.is_read ? $t('Mark as unread') : $t('Mark as read')"
          >
            <i v-if="!comment.is_read" class="far fa-envelope-open"></i>
            <i v-else class="far fa-envelope"></i>
          </button>

          <a
            class="btn btn-outline-primary"
            :href="routeConversation"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="$t('Go to conversation')"
          >
            <i class="far fa-arrow-alt-circle-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['rawComment', 'routeToggleRead', 'routeConversation'],
  data() {
    return {
      comment: this.rawComment,
      working: false,
    }
  },
  mounted() {
    bootstrap.Tooltip.getOrCreateInstance(this.$refs.button).enable()
  },
  change() {},
  computed: {
    message() {
      if (this.comment.is_read) {
        return this.$t('Read')
      }
      return this.$t('Unread')
    },
  },
  methods: {
    toggle() {
      if (this.working) {
        return false
      }
      this.working = true
      axios
        .patch(this.routeToggleRead)
        .then((response) => {
          this.comment = { ...this.comment, ...response.data }

          iziToast.info({
            title: this.$t('Info'),
            message: this.message,
            position: 'bottmLeft',
          })

          this.working = false
          return null
        })
        .then(() => {})
    },
  },
}
</script>
